/**
 * Entity types available in the system.
 * 
 * IMPORTANT: do not change values.
 */
export enum EntityType {
  /**
   * Data collection (aka DC). 
   */
  Collection = "collection",
  /**
   * Data upload (aka DU).
   */
  Upload = "upload",
  /**
   * Data utilization request/version (aka DUR).
   */
  Request = "request",
  /**
   * Virtual environment request/version (aka VER).
   */
  VirtualEnvironment = "virtualenv"
}
